module.exports = __webpack_public_path__ + "img/training.4cc9791e.jpg";